<template>
  <v-card tile v-if="money !== null">
    <v-card-title>
      <v-row>
        <v-col cols="12" class="d-flex justify-space-between">
          <span>Transakcija</span>
          <v-btn icon @click="editable = true" v-if="editable === false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="save" v-else>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-form :readonly="!editable">
            <v-autocomplete
              v-model="money.money_type_id"
              :items="moneyTypes"
              :search-input.sync="moneyTypesSearch"
              @click="loadMoneyTypes"
              item-text="name"
              item-value="id"
              label="Tip"
            ></v-autocomplete>
            <v-text-field label="Vrednost" v-model="money.value"></v-text-field>
            <v-textarea
              label="Zapiski"
              v-model="money.notes"
              outlined
            ></v-textarea>
            <v-autocomplete
              v-model="money.vehicle_id"
              :items="vehicles"
              :search-input.sync="vehicleSearch"
              @click="loadVehicles"
              item-text="registration_plate"
              item-value="id"
              label="Vozilo"
            ></v-autocomplete>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      money: null,
      editable: false,
      moneyTypes: [],
      moneyTypesSearch: "",
      vehicles: [],
      vehicleSearch: "",
    }),
    mounted() {
      this.loadMoney();
    },
    methods: {
      loadMoney() {
        this.$http
          .get("api/v1/money/" + this.$route.params.id)
          .then((response) => {
            this.money = response.data;
            if (response.data.money_type_id !== null) {
              this.moneyTypes.push(response.data.money_type);
            }
            if (response.data.vehicle_id !== null) {
              this.vehicles.push(response.data.vehicle);
            }
          });
      },
      loadMoneyTypes() {
        if (this.editable === false) {
          return;
        }
        this.$http.get("api/v1/money-types").then((response) => {
          this.moneyTypes = response.data;
        });
      },
      loadVehicles() {
        if (this.editable === false) {
          return;
        }
        this.$http
          .get("api/v1/vehicles", {
            params: {
              filters: {
                registration_plate: encodeURI("%" + this.vehicleSearch + "%"),
              },
            },
          })
          .then((response) => {
            this.vehicles = response.data.data;
          });
      },
      save() {
        this.$http
          .put("api/v1/money/" + this.$route.params.id, this.money)
          .then((response) => {
            this.money = response.data;
            this.editable = false;
          });
      },
    },
    watch: {
      vehicleSearch() {
        this.loadVehicles();
      },
    },
  };
</script>
<style></style>
